import useFetch from '../hooks/useFetch';

const getHorasExtras = async (dataRequest) => {  
  try {
    return await useFetch.fnPost('horasExtras/getHorasExtras', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const getEmpleadosSubordinados = async (dataRequest) => {  
  try {
    return await useFetch.fnPost('horasExtras/getEmpleadosSubordinados', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}


const getHorasExtrasEmpleado = async (dataRequest) => {  
  try {
    return await useFetch.fnPost('horasExtras/getHorasExtrasEmpleado', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const procesarHorasExtras = async (dataRequest) => {
  try {
    return await useFetch.fnPost('horasExtras/procesarHorasExtras', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const anularHorasExtras = async (dataRequest) => {  
  try {
    return await useFetch.fnPost('horasExtras/anularHorasExtras', dataRequest);

  } catch (error) {
    console.error('Error API: ', error);
  }
}

const actualizarEstadoHorasExtras = async (dataRequest) => {
  try {
    return await useFetch.fnPost('horasExtras/actualizarEstadoHorasExtras', dataRequest);

  } catch (error) {
    console.error('Error API: ', error);
  }
}

const ejecutarDeteccionManual = async () => {
  try {
    return await useFetch.fnPost('horasExtras/ejecutarDeteccionManual', {});
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const getEstadisticasJob = async () => {
  try {
    return await useFetch.fnGet('horasExtras/getEstadisticasJob');
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const getNominas = async () => {
  try {
    return await useFetch.fnGet('horasExtras/getNominas');
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const getNumerosNomina = async (dataRequest) => {
  try {
    return await useFetch.fnPost('horasExtras/getNumerosNomina', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const aplicarHorasExtrasSoftland = async (dataRequest) => {
  try {
    return await useFetch.fnPost('horasExtras/aplicarHorasExtrasSoftland', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const desaplicarHorasExtrasSoftland = async (dataRequest) => {
  try {
    return await useFetch.fnPost('horasExtras/desaplicarHorasExtrasSoftland', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const requestApi = {
  getHorasExtras,
  getEmpleadosSubordinados,
  getHorasExtrasEmpleado,
  procesarHorasExtras,
  anularHorasExtras,
  actualizarEstadoHorasExtras,
  ejecutarDeteccionManual,
  getEstadisticasJob,
  getNominas,
  getNumerosNomina,
  aplicarHorasExtrasSoftland,
  desaplicarHorasExtrasSoftland
}

export default requestApi;
